import { Injectable } from '@angular/core';
/**
 * @hidden
 */
var WindowContainerService = /** @class */ (function () {
    function WindowContainerService() {
    }
    Object.defineProperty(WindowContainerService.prototype, "container", {
        get: function () {
            return WindowContainerService.container;
        },
        set: function (container) {
            WindowContainerService.container = container;
        },
        enumerable: true,
        configurable: true
    });
    WindowContainerService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    WindowContainerService.ctorParameters = function () { return []; };
    return WindowContainerService;
}());
export { WindowContainerService };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dialog/dist/es/window/window-container.service.js
// module id = ../../../../@progress/kendo-angular-dialog/dist/es/window/window-container.service.js
// module chunks = vendor